'use client';

import { useMainMenu } from '@vimond/features/curated-content';
import { useLocale } from '@vimond/i18n';
import { getEnvVar } from '@vimond/utils/env';
import { useCookies } from 'react-cookie';
import { Link } from '../Link';
import { Artwork } from './Artwork';

export const ApplicationLogo = () => {
  const { locale } = useLocale();
  const [cookies] = useCookies(['alias']);
  const alias =
    (cookies.alias as string) ?? getEnvVar('NEXT_PUBLIC_CURATED_LIST_ALIAS');
  const { logo } = useMainMenu({ locale, alias });

  return (
    <Link href="/" data-testid="ApplicationLogo">
      <div className="relative mb-5 flex h-[100px] w-[200px]">
        {logo?.images?.defaultUrl && (
          <Artwork
            src={logo.images.defaultUrl}
            alt=""
            fill
            className="object-contain"
          />
        )}
      </div>
    </Link>
  );
};
